import { useState } from 'react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Form } from '@/components/ui/form';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import SpinnerButton from '@/components/common/SpinnerButton';
import Error from '@/components/common/Error';
import FormGeneral from './common/FormGeneral';

import { usePutRegion, useRegions } from '@/data/region';

const formSchema = z.object({
  name: z.string().min(1),
  timeZone: z.string().min(1)
});
const EditRegionDialog = ({ region, setOpen }) => {
  const [apiError, setApiError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const putRegion = usePutRegion();
  const regions = useRegions();

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: region.name,
      timeZone: region.timeZone
    }
  });

  const onSubmit = async (values) => {
    setSubmitting(true);
    try {
      setApiError('');
      const updatedRegion = await putRegion(region.id, values);
      await regions.mutate(
        (currentRegions) =>
          currentRegions.map((r) =>
            r.id === updatedRegion.id ? updatedRegion : r
          ),
        false
      );
      setSubmitting(false);
      setOpen(false);
    } catch (err) {
      setApiError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onOpenChange={setOpen}>
      <DialogContent className="w-[600px]">
        <DialogHeader>
          <DialogTitle>Edit Region</DialogTitle>
          <DialogDescription>{region.name}</DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormGeneral />
            {apiError && <Error error={apiError} />}
            <DialogFooter>
              <SpinnerButton loading={submitting}>Edit Region</SpinnerButton>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default EditRegionDialog;
